import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { ToastProvider, useToast } from './contexts/ToastContext';
import Toast from './components/Toast/Toast';
import Header from './components/Header/Header';
import Hero from './components/Hero/Hero';
import Stats from './components/Stats/Stats';
import Problems from './components/Problems/Problems';
import Solution from './components/Solution/Solution';
import OurStory from './components/OurStory/OurStory';
import FAQ from './components/FAQ/FAQ';
import FinalCTA from './components/FinalCTA/FinalCTA';
import Footer from './components/Footer/Footer';
import PrivacyPolicy from './components/PrivacyPolicy/PrivacyPolicy';
import './App.css';

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const LandingPage = () => {
  const { toast, hideToast } = useToast();
  return (
    <div className="App">
      <Header />
      <Hero />
      <Stats />
      <Problems />
      <Solution />
      <OurStory />
      <FAQ />
      <FinalCTA />
      <Footer />
      <Toast toast={toast} onClose={hideToast} />
    </div>
  );
};

const PrivacyPolicyPage = () => (
  <div className="App">
    <Header />
    <PrivacyPolicy />
    <Footer />
  </div>
);

function App() {
  return (
    <ToastProvider>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
      </Routes>
    </ToastProvider>
  );
}

export default App;
